// extracted by mini-css-extract-plugin
module.exports = {"callToBookHeader":"callToBookHeader_callToBookHeader__2s6qV","callToBook__imgBlock":"callToBookHeader_callToBook__imgBlock__snckJ"};